import React from 'react';
import { Textarea } from '../../../../components/ui/textarea';
import { AiButton, Field, StreamPreview, inputCls } from '../shared';

export const validate = (wf) => (wf.data?.research?.outline_text?.trim() ? null : 'Add an outline before drafting.');

const outlineToText = (outline = []) =>
  outline.map((s) => `## ${s.heading}\n${(s.points || []).map((p) => `- ${p}`).join('\n')}`).join('\n\n');

const StepResearch = ({ wf, setData, runAi, ai }) => {
  const d = wf.data?.research || {};
  const running = ai.running && ai.action === 'research';

  const research = async () => {
    const res = await runAi('research');
    if (res) {
      setData('research', {
        ai: res,
        outline_text: outlineToText(res.outline),
        facts_text: (res.key_facts || []).map((f) => `- ${f.fact}${f.source_hint ? ` (${f.source_hint})` : ''}`).join('\n'),
        sources_text: (res.sources_to_cite || []).map((s) => `- ${s}`).join('\n'),
        differentiation: res.differentiation || '',
      });
    }
  };

  return (
    <div className="space-y-6">
      <AiButton onClick={research} running={running} label="Research with AI" runningLabel="Researching…" testId="research-generate-btn" />
      {running && <StreamPreview text={ai.text} label="Building research brief…" />}
      <Field label="Outline" required hint="## for sections, - for talking points. Edit freely — the draft follows this." testId="research-outline-field">
        <Textarea value={d.outline_text || ''} onChange={(e) => setData('research', { outline_text: e.target.value })} rows={14} className={`${inputCls} font-mono text-sm`} data-testid="research-outline-input" />
      </Field>
      <div className="grid md:grid-cols-2 gap-5">
        <Field label="Key facts to include" hint="Anything unverifiable is flagged again in Factual Verification." testId="research-facts-field">
          <Textarea value={d.facts_text || ''} onChange={(e) => setData('research', { facts_text: e.target.value })} rows={8} className={`${inputCls} text-sm`} />
        </Field>
        <Field label="Sources to cite" testId="research-sources-field">
          <Textarea value={d.sources_text || ''} onChange={(e) => setData('research', { sources_text: e.target.value })} rows={8} className={`${inputCls} text-sm`} />
        </Field>
      </div>
      <Field label="How this article will differ from what already ranks" testId="research-diff-field">
        <Textarea value={d.differentiation || ''} onChange={(e) => setData('research', { differentiation: e.target.value })} rows={3} className={inputCls} />
      </Field>
    </div>
  );
};

export default StepResearch;
